import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Site } from '../site';
import { map, Observable, switchMap } from 'rxjs';
import { Pool, Swimlane } from './pool';
import { Substep } from './appointment';

@Injectable({
  providedIn: 'root'
})
export class QueueService {

  constructor(private http: HttpClient) { }

  getSites(): Observable<Site[]> {
    return this.http.get<Site[]>("/api/sites")
    .pipe(map(response =>{
      return response;
    }));
  }

  getPossibleSwimlanes(): Observable<{[key: number]: Pool}> {
    return this.http.get<{[key: number]: Pool}>(`/api/getPools`)
    .pipe(map( response => {
      return response
    }))
  }

  getPossibleSubsteps(): Observable<PossibleSubsteps> {
    return this.http.get<PossibleSubsteps>(`/api/getPossibleSubsteps`)
    .pipe(map((response) => {
      return response
    }));
  }

  getProgressionSteps(date: string, siteId: number): Observable<ProgressionStep[]> {
    return this.http.get<ProgressionStep[]>(`/api/getProgressionSteps?action=getProgressionSteps&date=${date}&siteId=${siteId}`)
    .pipe(map( response => {
      return response
    }))
  }
  deleteTimestamp(appointmentId: number, stepId: number): Observable<boolean> {
    const data = `appointmentId=${appointmentId}&stepId=${stepId}`
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    
    return this.http.post('/api/queue/deleteTimestamp', data, {headers: baseHeaders})
    .pipe(map((response) => {
      return true
    }))
  }
  insertStepTimestamp(appointmentId: number, stepId: number, setTimeStampToNull: boolean, updateTimeIn: boolean): Observable<boolean> {
    const data = `appointmentId=${appointmentId}&stepId=${stepId}&setTimeStampToNull=${setTimeStampToNull}&updateTimeIn=${updateTimeIn}`
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    
    return this.http.post('/api/queue/insertStepTimestamp', data, {headers: baseHeaders})
    .pipe(map((response) => {
      return true
    }))
  }

  insertSubstepTimestamp(appointmentId: number, substepId:number): Observable<boolean> {
    const data = `appointmentId=${appointmentId}&substepId=${substepId}`
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post('/api/queue/insertSubstepTimestamp', data,
      {headers: baseHeaders})
      .pipe(map((response) => {
        return true
      }));
  }

  markAppointmentAsCompleted(appointmentId: number): Observable<boolean> {
    const data = `appointmentId=${appointmentId}`
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<StandardResult>('/api/queue/completeAppointment', data,
      {headers: baseHeaders})
      .pipe(map((response) => {
        return response.success
      }));
  }
  
  markAppointmentAsIncomplete(appointmentId: number): Observable<boolean> {
    const data = `appointmentId=${appointmentId}`
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post('/api/queue/incompleteAppointment', data,
      {headers: baseHeaders})
      .pipe(map((response) => {
        return true
      }));
  }
  
  markAppointmentAsCancelled(appointmentId: number): Observable<boolean> {
    const data = `appointmentId=${appointmentId}`
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post('/api/queue/cancelAppointment', data,
      {headers: baseHeaders})
      .pipe(map((response) => {
        return true
      }));
  }
}

interface PotentialProgressionSteps {
  progressionTypeId: number
  progressionTypeName: string
  progressionStepId: number
  progressionStepOrdinal: number
  progressionStepName: string
}

interface ResponseSite {
  siteId: number
  title: string
}

interface ProgressionStep {
  advancement_rank: number | undefined
  appointmentId: number | null
  appointmentType: string
  cancelled: boolean
  clientId: number
  clientName: string
  answersByLookup: any
  emailAddress: string
  firstName: string
  lastName: string
  language: string | undefined
  phoneNumber: string
  progressionStepName: string | undefined
  progressionStepOrdinal: number
  progressionSubStepId: number | undefined
  progressionSubstepName: string | undefined
  progressionTypeId: number | undefined
  progressionTypeName: string | undefined
  scheduledDatetime: string
  scheduledTime: string
  timestamp: string | undefined
  visa: string | undefined
  walkIn: boolean
  noShow: boolean | undefined
  ended: boolean | undefined
  preparing: boolean | undefined
}

interface ProgressionStepResults {
  success: boolean
  progressionSteps: ProgressionStep[]
}

interface StandardResult {
  success: boolean
}

interface PossibleSubsteps {
  success: boolean
  possibleSubsteps: Substep[]
}